// extracted by mini-css-extract-plugin
export default {"ModalPhone":"Modal_ModalPhone__1u3jA"};